module.exports = __webpack_public_path__ + "static/media/Temp-dom.a2181672.svg";